import { FAQData } from 'model/Faq';

const faqData: FAQData[] = [
  {
    id: 1,
    type: 'General FAQs',
    sections: [
      {
        id: 1,
        title: `About Move2NewCity`,
        items: [
          {
            id: 1,
            question: `What is Move2NewCity?`,
            answer: `Move2NewCity is an online platform designed to assist individuals and families who are planning to move to a new city. It provides a wide range of resources and information to help make your relocation process smooth and stress-free. More importantly, Move2NewCity helps to connect with real people with lived experiences in the new city.`,
          },
          {
            id: 2,
            question: `What are the services provided by Move2NewCity?`,
            answer: `Move2NewCity facilitates newcomers to a new city by asking questions from friends who live in that city about areas such as accommodation, employment, education, food, healthcare, transportation, and many more.`,
          },
          {
            id: 3,
            question: `Is Move2NewCity a global platform?`,
            answer: `Currently, our primary focus is on facilitating migration to Australia. However, we are soon hoping to extend our services globally within the upcoming months.`,
          },
          {
            id: 4,
            question: `Is Move2NewCity free to use?`,
            answer: `Yes, Move2NewCity is entirely free to use. We aim to provide valuable information and assistance to make your relocation process as smooth as possible without any cost to you.`,
          },
          {
            id: 5,
            question: `Can I access Move2NewCity from any device, such as smartphones or tablets?`,
            answer: `The Move2NewCity website is fully optimized to ensure seamless access from any device, allowing you to browse it conveniently, anytime, anywhere.`,
          },
          {
            id: 6,
            question: `Can I search for specific cities on Move2NewCity?`,
            answer: `To search for available cities, please use the search bar. Enter the name of an available city you are interested in and you will receive detailed information about that location.`,
          },
        ],
      },
      {
        id: 2,
        title: `Login/Signup`,
        items: [
          {
            id: 7,
            question: `How can I sign up on Move2NewCity?`,
            answer: `You can sign up as a friend or newcomer using your Google, Facebook, or Email account.<br/>You cannot, however, use the same email address to sign up both as a friend and a newcomer.`,
          },
          {
            id: 8,
            question: `What are the rules for an email address to be considered valid when signing up for an account?`,
            answer: `The email address must follow the standard email address format, which is: username@domain.com`,
          },
          {
            id: 9,
            question: `What are the rules for a password to be considered valid when signing up for a account?`,
            answer: `Passwords must be at least 8 characters long and contain a mix of uppercase and lowercase letters, numbers, and special characters. They should also be unique and changed regularly to decrease chances of account theft.`,
          },
        ],
      },
      {
        id: 3,
        title: `Edit Account`,
        items: [
          {
            id: 10,
            question: `How can I edit my account details?`,
            answer: `To edit your account details, please follow the below steps:
                <ul class= "list-disc list-inside ml-6"><li>Sign in to your account.</li>
                <li>Click on your profile icon.</li>
                <li>Click on "Edit account".</li>
                <li>Make the changes you want to your account details.</li>
                <li>Click on "Save".</li></ul>`,
          },
          {
            id: 11,
            question: `Can I edit the categories I am interested in?`,
            answer: `To change interested categories:
                <ul class= "list-disc list-inside ml-6"><li>Click on profile icon.</li>
                <li>Click on "Edit account".</li>
                <li>Add new categories.</li>
                <li>Click "Save".</li></ul>`,
          },
          {
            id: 12,
            question: `How can I update my personal information?`,
            answer: `You can update your personal information by clicking on the profile icon on the top right corner and selecting the "Edit account" option.`,
          },
          {
            id: 13,
            question: `Can I change my account email?`,
            answer: `We currently do not support email changes. If you are experiencing any problems, please contact us so that we can assist you.`,
          },
        ],
      },
      {
        id: 4,
        title: `Password`,
        items: [
          {
            id: 14,
            question: `How do I change my password?`,
            answer: `To change your password please follow the below steps:
              <ul class= "list-disc list-inside ml-6"><li>Go to the login page and click on the "Forgot Password?" link.</li>
              <li>Enter your email address in the field provided.</li>
              <li>Click on the "Send" button.</li>
              <li>Check your email for a message from us. The message will contain a link that you can click on to reset your password.</li>
              <li>Click on the link and enter a new password.</li>
              <li>Click on the "Reset Password" button.</li></ul>
              Please make the necessary changes to the password.`,
          },
          {
            id: 15,
            question: `What should I do if I cannot find or did not receive the link to change the password?`,
            answer: `Please check your spam folder to see if our email was sent there. If you do not find it, please contact us through the link provided so that we can assist you further. <a href="https://www.move2newcity.com/contact-us">https://www.move2newcity.com/contact-us</a>`,
          },
        ],
      },
      {
        id: 5,
        title: `Privacy Policy and Terms of Services`,
        items: [
          {
            id: 16,
            question: `Is my personal information secure?`,
            answer: `Your privacy and security are of utmost importance to us. Any information that we hold about you is stored on secure servers that are protected in controlled facilities and accessing these details by you will always be authenticated by you with your consent.<br/><br/>To learn more please read our Privacy Policy here: <a href="https://www.move2newcity.com/privacy-policy#user-consent">https://www.move2newcity.com/privacy-policy#user-consent</a>`,
          },
          {
            id: 17,
            question: `How can I delete my account?`,
            answer: `Currently we don't allow deletion of accounts.`,
          },
          {
            id: 18,
            question: `What are Move2NewCity's Terms of Service and Privacy Policy?`,
            answer: `You can view the 'Terms and Conditions' and 'Privacy Policy' here:
                <ul class= "list-disc list-inside ml-6"><li>Terms and Conditions: <a href="https://www.move2newcity.com/terms-and-conditions">https://www.move2newcity.com/terms-and-conditions</a></li>
                <li>Privacy Policy: <a href="https://www.move2newcity.com/privacy-policy">https://www.move2newcity.com/privacy-policy</a></li></ul>`,
          },
        ],
      },
      {
        id: 6,
        title: `Support`,
        items: [
          {
            id: 19,
            question: `How can I get in touch with Move2NewCity for additional support or inquiries?`,
            answer: `If you have any questions, or feedback, or need further assistance, you can reach out to us through the "Contact Us" section at the bottom of our website or visit <a href="https://www.move2newcity.com/contact-us">https://www.move2newcity.com/contact-us</a> and fill out this form. We value your input and are always ready to help!`,
          },
          {
            id: 20,
            question: `How do I report inappropriate content or users?`,
            answer: `Our team of admins moderates all answers to ensure that they comply with our terms of service. However, if you see any inappropriate content or users, please report it to us through our contact us page. We will investigate the matter and take appropriate action.`,
          },
        ],
      },
      {
        id: 7,
        title: `Emails`,
        items: [
          {
            id: 21,
            question: `How do I unsubscribe from email notifications?`,
            answer: `To unsubscribe from an email, please click on the link at the bottom of the email. This will take you to a page where you can confirm your request to unsubscribe.`,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    type: 'FAQs for Friend',
    sections: [
      {
        id: 1,
        title: `About Friend`,
        items: [
          {
            id: 1,
            question: `Who is a friend?`,
            answer: `A friend is someone who is willing to help others and who is knowledgeable about a particular city. They are someone who can provide advice and assistance to newcomers, help them find their way around, and introduce them to new places and people. Friends are a valuable resource for newcomers, and they can make the process of settling into a new city much easier.`,
          },
          {
            id: 2,
            question: `What are the requirements to become a friend?`,
            answer: `To become a friend, you must be willing to share your lived experiences of a city with newcomers. You must also be knowledgeable about the city and be able to answer questions about it. You must be able to communicate effectively with newcomers.`,
          },
          {
            id: 3,
            question: `How can I become a top friend?`,
            answer: `Based on the upvotes and downvotes received for the answers given by you, our rating system will assign a star rating for each category that you have added answers to.`,
          },
        ],
      },
      {
        id: 2,
        title: `Answering Questions`,
        items: [
          {
            id: 4,
            question: `Why can't I answer a question?`,
            answer: `There are several reasons why you might not be able to answer a question:
                <ul class= "list-disc list-inside ml-6"><li>You haven't verified your email (If signed in using an email).</li>
                <li>You've answered a question on a city that you haven't registered for.</li>
                <li>You've already replied once (Only one reply per question).</li></ul>`,
          },
          {
            id: 5,
            question: `How many answers can I provide for a question asked by a Newcomer?`,
            answer: `You can provide only one answer per question. However, you can schedule calls with Newcomers to provide additional details regarding their questions.`,
          },
          {
            id: 6,
            question: `Can I reply to questions about other cities?`,
            answer: `Unfortunately, you cannot answer questions about other cities.`,
          },
          {
            id: 7,
            question: `Can I delete a reply?`,
            answer: `At the moment, we do not allow the deletion of answers. However before an answer is posted on the Move2NewCity platform, it will go under a stringent process of moderation to ensure that no duplicate or inappropriate content is published on the platform.`,
          },
        ],
      },
      {
        id: 3,
        title: `Availability and Calls`,
        items: [
          {
            id: 8,
            question: `How can I set my availability?`,
            answer: `To change your availability:
              <ul class= "list-disc list-inside ml-6">
                <li>Click on your profile icon.</li>
                <li>Click on "Availability".</li>
                <li>You can change your:</li>
                     <ul>
                      <li class="ml-8 relative pl-8 before:content-[''] before:absolute before:left-2 before:top-1/2 before:transform before:-translate-y-1/2 before:w-1.5 before:h-1.5 before:bg-transparent before:border before:border-black before:rounded-full">Call duration</li>
                      <li class="ml-8 relative pl-8 before:content-[''] before:absolute before:left-2 before:top-1/2 before:transform before:-translate-y-1/2 before:w-1.5 before:h-1.5 before:bg-transparent before:border before:border-black before:rounded-full">Time zone</li>
                      <li class="ml-8 relative pl-8 before:content-[''] before:absolute before:left-2 before:top-1/2 before:transform before:-translate-y-1/2 before:w-1.5 before:h-1.5 before:bg-transparent before:border before:border-black before:rounded-full">Weekly work hours</li>
                      <li class="ml-8 relative pl-8 before:content-[''] before:absolute before:left-2 before:top-1/2 before:transform before:-translate-y-1/2 before:w-1.5 before:h-1.5 before:bg-transparent before:border before:border-black before:rounded-full">Date overrides</li>
                     </ul>
              </ul>`,
          },
          {
            id: 9,
            question: `Can I reschedule a call?`,
            answer: `Currently, we do not allow friends to reschedule calls, however, friends can suggest new times.  `,
          },
          {
            id: 10,
            question: `Can I cancel a call?`,
            answer: `Currently, we do not allow friends to cancel calls.`,
          },
          {
            id: 11,
            question: `Can I host group calls?`,
            answer: `Currently, we do not allow users to host group calls.`,
          },
          {
            id: 12,
            question: `What are the platforms that can be used to join a meeting?`,
            answer: `As of now, all meetings are hosted via Google Meets.`,
          },
          {
            id: 13,
            question: `How am I going to get notified about a scheduled call?`,
            answer: `You will receive email notifications about upcoming calls.<br/>Furthermore, notifications will appear under the notification tab at the top right of the website. Simply click on it to keep up with meetings, upvotes, replies and general information.<br/>Notifications about calls will appear as a yellow call icon.`,
          },
          {
            id: 14,
            question: `Can I set reminders for calls?`,
            answer: `You can add up to two reminders to your calls. These reminders can be set for a specific time or date, and they will be sent to you as a notification. `,
          },
          {
            id: 15,
            question: `Can I add a call to my calendar?`,
            answer: `Meetings will be automatically added to the calendar associated with the email address you used to sign up.`,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    type: 'FAQs for Newcomer',
    sections: [
      {
        id: 1,
        title: `About Newcomer`,
        items: [
          {
            id: 1,
            question: `Who is a Newcomer?`,
            answer: `A newcomer is anyone who seeks assistance in moving to a new city. As a newcomer, you have the ability to ask questions and get one-on-one calls with friends, and be a part of an amazing community!`,
          },
        ],
      },
      {
        id: 2,
        title: `Asking Questions`,
        items: [
          {
            id: 2,
            question: `How can I ask questions on Move2NewCity?`,
            answer: `To ask a question:
                <ul class= "list-disc list-inside ml-6"><li>Log in as a Newcomer.</li>
                <li>Select the city in which you require the information.</li>
                <li>You will be redirected to a page with questions and answers provided by different users within the system.</li>
                <li>Select the "Ask a Question" button under the categories in the top right corner if you wish to ask a new question.</li></ul>`,
          },
          {
            id: 3,
            question: `Why can't I ask a question?`,
            answer: `If you signed up using email, as opposed to verified options, you will not be able to ask questions until you verify your account through a link sent to your email.`,
          },
          {
            id: 4,
            question: `Why is my question not posted?`,
            answer: `We always try to make sure that the content provided on our platform is accurate and up to date. Our content moderators are continuously monitoring the content on the platofrm before publishing. If your content is not published it could be due to one of the following reasons.
                <ul class= "list-disc list-inside ml-6"><li>Spam</li>
                <li>Inappropriate content</li>
                <li>Duplicate content</li>
                <li>Poor language quality</li>
                <li>Violation of public ethics</li></ul>`,
          },
          {
            id: 5,
            question: `Can Friends view my details?`,
            answer: `Your personal information is not shared with friends. However, they will be able to see your name, image, the questions asked by you, and the email.`,
          },
          {
            id: 6,
            question: `How can I delete a question?`,
            answer: `At the moment, we do not allow the deletion of questions. However before a question is posted on the Move2NewCity platform, it will go under a precise process of moderation to ensure that no duplicate or inappropriate content is published on the platform.`,
          },
          {
            id: 7,
            question: `How can I verify the credibility of answers provided by Friends?`,
            answer: `Our team of friends is committed to providing you with the best possible experience. To become a part of our team, you must agree to our terms and conditions, to be honest.  To uphold the highest quality standards, every response undergoes a rigorous review process led by our diligent panel of content moderators who conduct meticulous fact-checking before publication. We are dedicated to providing credible and trustworthy information for your benefit.`,
          },
        ],
      },
      {
        id: 3,
        title: `Scheduling Calls`,
        items: [
          {
            id: 8,
            question: `Is Move2NewCity's call feature free to use?`,
            answer: `The use of Move2NewCity's call feature is currently free for users to schedule and initiate calls.`,
          },
          {
            id: 9,
            question: `How can I schedule a call?`,
            answer: `To schedule a call with a friend on our website, follow these steps:
                <ul class= "list-disc list-inside ml-6"><li>Go to the home screen and enter the city you want to move to.</li>
                <li>You will see a list of friends from that city who can answer your questions.</li>
                <li>Click on a friend whose expertise matches your questions.</li>
                <li>Click on "Schedule a call".</li>
                <li>You will need to verify your email before scheduling a call.</li>
                <li>Write a brief description of the topics you want to cover in the call, enter the estimated - duration, and select a date and time.</li>
                <li>To manage your calls, click on the profile icon and then click on "Scheduled calls".</li></ul>`,
          },
          {
            id: 10,
            question: `Are there any restrictions on call durations?`,
            answer: `The maximum call duration is 45 minutes. We offer three standard call durations of 15, 30, and 45 minutes.`,
          },
          {
            id: 11,
            question: `Is it required for both me and my friend to have a Move2NewCity account in order to schedule a call?`,
            answer: `Yes, both you and your friend will need to have a Move2NewCity account in order to schedule a call.`,
          },
          {
            id: 12,
            question: `How can I reschedule a call?`,
            answer: `To reschedule a call as a newcomer:
                <ul class= "list-disc list-inside ml-6"><li>Log in to your account and go to your user profile.</li>
                <li>Click on the "Scheduled calls" tab.</li>
                <li>Locate the call that you want to reschedule.</li>
                <li>Click on the "Reschedule" button.</li>
                <li>Select a new date and time for the call.</li>
                <li>Click on the "Reschedule" button.</li></ul>`,
          },
          {
            id: 13,
            question: `How can I cancel a call?`,
            answer: `To cancel a call as a newcomer:
                <ul class= "list-disc list-inside ml-6">
                <li>Log in to your account and go to your user profile.</li>
                <li>Click on the "Scheduled calls" tab.</li>
                <li>Locate the call that you want to cancel.</li>
                <li>Click on the "Cancel the call" button.</li>
                <li>Enter the reason why you are canceling the call.</li>
                <li>Click on the "Yes, Cancel the call" button to confirm the cancellation.</li>
                </ul>`,
          },
        ],
      },
    ],
  },
];

export default faqData;
